import { AttachmentRule, Behavior } from "./types";

export class RandomCharacterMeshBehavior extends Behavior {
  private minId: number = 1;
  private maxId: number = 100;
  //private baseUrl: string =
  // "https://avatar-combinati-f98a58--imp-sandbox-4ac146.msquaredhosting.com/";
  //private baseUrl: string = "https://storage.googleapis.com/glb-content-bucket/sandbox/glb/"

  private baseUrl: string =
    "https://spike-glb-optimizer.preview.msquared.io/api/convert?target=200&url=https://casual-filtered-v1.msquaredavatars.com/";

  static getAttachmentRules(): AttachmentRule[] {
    return [{ type: "class", selector: "random-character-mesh" }];
  }

  onAttach(): void {
    console.log("RandomCharacterMeshBehavior attached to:", this.element);

    // Read ID bounds from attributes if they exist
    const minIdAttr = this.element.getAttribute("min-id");
    const maxIdAttr = this.element.getAttribute("max-id");
    const baseUrlAttr = this.element.getAttribute("base-url");

    if (minIdAttr) {
      this.minId = parseInt(minIdAttr) || this.minId;
    }

    if (maxIdAttr) {
      this.maxId = parseInt(maxIdAttr) || this.maxId;
    }

    if (baseUrlAttr) {
      this.baseUrl = baseUrlAttr;
    }

    // Ensure min is not greater than max
    if (this.minId > this.maxId) {
      [this.minId, this.maxId] = [this.maxId, this.minId];
    }

    // Generate random ID between minId and maxId (inclusive)
    const randomId = Math.floor(Math.random() * (this.maxId - this.minId + 1)) + this.minId;

    // Construct the URL with the random ID
    const meshUrl = `${this.baseUrl}${randomId}.glb`;

    // Apply the mesh URL to the element
    this.element.setAttribute("src", meshUrl);

    console.log(
      `RandomCharacterMeshBehavior: Applied mesh URL ${meshUrl} (ID: ${randomId}, range: ${this.minId}-${this.maxId})`,
    );
  }

  onDetach(): void {
    console.log("RandomCharacterMeshBehavior detached from:", this.element);
    // Optionally reset src when detaching
    // this.element.removeAttribute('src');
  }
}
